/**
 * Enum class for AppointmentType levels
 *
 * @class AppointmentTypeLevelEnum
 */
module.exports = {
  GLOBAL: 'GLOBAL',
  SERVICE: 'SERVICE',
  APPOINTMENT: 'APPOINTMENT'
};
